import { render } from "./index.vue?vue&type=template&id=2d1a92fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2d1a92fa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d1a92fa"

export default script